<div class="profile-container" id="holding-container">
  <div class="column-0">
    <div class="settings-section">
      <div class="avatar-section">
        <div
          style="background-image: url('{{ userProfileImage }}')"
          alt="Avatar"
          class="avatar-img"
        >
          <span *ngIf="!userProfileImage" class="avatar-initials">
            {{ userInitials }}</span
          >
          <input
            type="file"
            accept=".jpeg, .jpg, .png, .svg"
            (change)="uploadFile($event)"
            id="file-upload"
            class="file-input avatar"
            *ngIf="!isPreview"
          />
        </div>
        <div class="avatar-right">
          <button
            class="change-avatar-btn not-selectable"
            for="file-upload"
            [disabled]="isPreview"
            [class.disabled]="isPreview"
            (click)="onAvatarChange($event)"
          >
            {{ 'labels.changeAvatar' | translate }}
          </button>
          <div class="avatar-info not-selectable">
            {{ 'labels.optimalSize' | translate }} 256×256 (JPG, PNG)
          </div>
        </div>
      </div>

      <div class="profile-form">
        <ops-input
          (validationError)="onErrorHandler($event, 'firstName')"
          [isPreview]="isPreview"
          [label]="'labels.firstName' | translate"
          mandatory="true"
          formName="firstName"
          [value]="userEdit.firstName"
          (changed)="onInputChange($event, 'firstName')"
          type="text"
        ></ops-input>

        <ops-input
          (validationError)="onErrorHandler($event, 'lastName')"
          [isPreview]="isPreview"
          [label]="'labels.lastName' | translate"
          formName="lastName"
          mandatory="true"
          [value]="userEdit.lastName"
          (changed)="onInputChange($event, 'lastName')"
          type="text"
        ></ops-input>

        <ops-input
          (validationError)="onErrorHandler($event, 'username')"
          [isPreview]="isPreview"
          [label]="'labels.username' | translate"
          formName="username"
          mandatory="true"
          [value]="userEdit.username"
          (changed)="onInputChange($event, 'username')"
          type="text"
        ></ops-input>

        <ops-select
          [isPreview]="isPreview"
          [options]="genderOptions"
          showSearch="true"
          allowCreate="true"
          [defaultSelected]="userEdit.gender"
          [formName]="userEdit.gender"
          [label]="'labels.gender' | translate"
          (changed)="onSelectChange($event, 'gender')"
        ></ops-select>

        <ops-calendar
          [label]="'labels.dateOfBirth' | translate"
          (dateChanged)="updateFullDate($event)"
          [isPreview]="isPreview"
          (validationError)="onErrorHandler($event, 'year')"
          formName="dateOfBirth"
          [maxDate]="maxBirthDate"
          [date]="userEdit.dateOfBirth"
        ></ops-calendar>
      </div>
    </div>
    <div class="settings-section no-bottom">
      <div class="profile-form">
        <ops-select
          [isPreview]="isPreview"
          [options]="professionalRolesList"
          showSearch="true"
          allowCreate="true"
          [defaultSelected]="userEdit.professionalRoles"
          [formName]="userEdit.professionalRoles"
          isMultiselect="true"
          showLimitNote="true"
          maxSelect="2"
          [label]="'labels.professionalRole' | translate"
          (changed)="onSelectChange($event, 'professionalRoles')"
        ></ops-select>

        <ops-select
          [isPreview]="isPreview"
          [options]="businessTypes"
          showSearch="true"
          allowCreate="true"
          [defaultSelected]="userEdit.businessType"
          [formName]="userEdit.businessType"
          [type]="'radio'"
          showLimitNote="true"
          maxSelect="1"
          [label]="'labels.businessType' | translate"
          (changed)="onSelectChange($event, 'businessType')"
        ></ops-select>

        <ops-select
          [isPreview]="isPreview"
          [options]="creativeIndustrySectorsList"
          showSearch="true"
          allowCreate="true"
          [defaultSelected]="userEdit.creativeIndustrySectors"
          [type]="'checkbox'"
          [formName]="userEdit.creativeIndustrySectors"
          rotateDropdownDirection="true"
          isMultiselect="true"
          showLimitNote="true"
          maxSelect="2"
          [label]="'labels.creativeIndustrySector' | translate"
          (changed)="onSelectChange($event, 'creativeIndustrySectors')"
        ></ops-select>

        <ops-select
          [isPreview]="isPreview"
          [options]="marketDomainsList"
          showSearch="true"
          allowCreate="true"
          [type]="'checkbox'"
          rotateDropdownDirection="true"
          [defaultSelected]="userEdit.marketDomains"
          [formName]="userEdit.marketDomains"
          showLimitNote="true"
          isMultiselect="true"
          maxSelect="3"
          [label]="'labels.marketDomain' | translate"
          (changed)="onSelectChange($event, 'marketDomains')"
        ></ops-select>
      </div>
    </div>
  </div>

  <div class="column-1">
    <div class="settings-section">
      <label class="section-label">{{
        'labels.personalAndProfessionalPreferences' | translate
      }}</label>
      <div class="profile-form">
        <ops-select
          [isPreview]="isPreview"
          [options]="fieldOfExpertises"
          showSearch="true"
          allowCreate="true"
          [defaultSelected]="userEdit.fieldOfExpertise"
          [formName]="userEdit.fieldOfExpertise"
          [label]="'labels.fieldOfExpertise' | translate"
          (changed)="onSelectChange($event, 'fieldOfExpertise')"
        ></ops-select>

        <ops-select
          [isPreview]="isPreview"
          [options]="workStyleAndPreferences"
          showSearch="true"
          allowCreate="true"
          [defaultSelected]="userEdit.workStyleAndPreference"
          [formName]="userEdit.workStyleAndPreference"
          [label]="'labels.workStyleAndPreference' | translate"
          (changed)="onSelectChange($event, 'workStyleAndPreference')"
        ></ops-select>

        <ops-input
          [isPreview]="isPreview"
          [label]="'labels.digitalTools' | translate"
          formName="userEdit.digitalTools"
          [value]="userEdit.digitalTools"
          (changed)="onInputChange($event, 'digitalTools')"
          type="text"
        ></ops-input>

        <ops-select
          [isPreview]="isPreview"
          [options]="preferredCommunicationMethods"
          showSearch="true"
          allowCreate="true"
          [defaultSelected]="userEdit.preferredCommunicationMethod"
          [formName]="userEdit.preferredCommunicationMethod"
          [label]="'labels.preferredCommunicationMethod' | translate"
          (changed)="onSelectChange($event, 'preferredCommunicationMethod')"
        ></ops-select>

        <ops-select
          [isPreview]="isPreview"
          [options]="preferredCommunicationStyles"
          showSearch="true"
          allowCreate="true"
          [defaultSelected]="userEdit.preferredCommunicationStyle"
          [formName]="userEdit.preferredCommunicationStyle"
          [label]="'labels.preferredCommunicationStyle' | translate"
          (changed)="onSelectChange($event, 'preferredCommunicationStyle')"
        ></ops-select>

        <ops-select
          [isPreview]="isPreview"
          [options]="teamPlays"
          showSearch="true"
          allowCreate="true"
          [defaultSelected]="userEdit.teamPlay"
          [formName]="userEdit.teamPlay"
          [label]="'labels.teamPlay' | translate"
          (changed)="onSelectChange($event, 'teamPlay')"
        ></ops-select>

        <ops-input
          [isPreview]="isPreview"
          [label]="'labels.workTools' | translate"
          formName="userEdit.workTools"
          [value]="userEdit.workTools"
          (changed)="onInputChange($event, 'workTools')"
          type="text"
        ></ops-input>

        <ops-input
          [isPreview]="isPreview"
          [label]="'labels.interestsAndInspirations' | translate"
          formName="userEdit.interestsAndInspirations"
          [value]="userEdit.interestsAndInspirations"
          (changed)="onInputChange($event, 'interestsAndInspirations')"
          type="text"
        ></ops-input>

        <ops-input
          [isPreview]="isPreview"
          [label]="'labels.favoriteArtistsArtworkAndCultures' | translate"
          formName="userEdit.favoriteArtistsArtworkAndCultures"
          [value]="userEdit.favoriteArtistsArtworkAndCultures"
          (changed)="onInputChange($event, 'favoriteArtistsArtworkAndCultures')"
          type="text"
        ></ops-input>

        <ops-input
          [isPreview]="isPreview"
          [label]="'labels.leisurelyActivities' | translate"
          formName="userEdit.leisurelyActivities"
          [value]="userEdit.leisurelyActivities"
          (changed)="onInputChange($event, 'leisurelyActivities')"
          type="text"
        ></ops-input>
      </div>
    </div>
  </div>

  <div class="column-2">
    <div class="settings-section">
      <label class="section-label">{{ 'labels.socials' | translate }}</label>
      <div class="profile-form two-cols">
        <div class="left-block">
          <ops-input
            (validationError)="onErrorHandler($event, 'website')"
            [isPreview]="isPreview"
            [label]="'labels.website' | translate"
            formName="website"
            [value]="userEdit.website"
            (changed)="onInputChange($event, 'website')"
            type="url"
          ></ops-input>

          <ops-input
            (validationError)="onErrorHandler($event, 'linkedin')"
            [isPreview]="isPreview"
            [label]="'labels.linkedin' | translate"
            formName="linkedin"
            [value]="userEdit.linkedin"
            (changed)="onInputChange($event, 'linkedin')"
            type="url"
          ></ops-input>

          <ops-input
            (validationError)="onErrorHandler($event, 'youtube')"
            [isPreview]="isPreview"
            [label]="'labels.youtube' | translate"
            formName="youtube"
            [value]="userEdit.youtube"
            (changed)="onInputChange($event, 'youtube')"
            type="url"
          ></ops-input>

          <ops-input
            (validationError)="onErrorHandler($event, 'vimeo')"
            [isPreview]="isPreview"
            [label]="'labels.vimeo' | translate"
            formName="vimeo"
            [value]="userEdit.vimeo"
            (changed)="onInputChange($event, 'vimeo')"
            type="url"
          ></ops-input>
        </div>
        <div class="right-block">
          <ops-input
            (validationError)="onErrorHandler($event, 'instagram')"
            [isPreview]="isPreview"
            [label]="'labels.instagram' | translate"
            formName="instagram"
            [value]="userEdit.instagram"
            (changed)="onInputChange($event, 'instagram')"
            type="url"
          ></ops-input>

          <ops-input
            (validationError)="onErrorHandler($event, 'tiktok')"
            [isPreview]="isPreview"
            [label]="'labels.tiktok' | translate"
            formName="tiktok"
            [value]="userEdit.tiktok"
            (changed)="onInputChange($event, 'tiktok')"
            type="url"
          ></ops-input>

          <ops-input
            (validationError)="onErrorHandler($event, 'imdb')"
            [isPreview]="isPreview"
            [label]="'labels.imdb' | translate"
            formName="imdb"
            [value]="userEdit.imdb"
            (changed)="onInputChange($event, 'imdb')"
            type="url"
          ></ops-input>

          <ops-input
            (validationError)="onErrorHandler($event, 'x')"
            [isPreview]="isPreview"
            [label]="'labels.x' | translate"
            formName="x"
            [value]="userEdit.x"
            (changed)="onInputChange($event, 'x')"
            type="url"
          ></ops-input>
        </div>
      </div>

      <div
        class="additional-channels"
        *ngIf="!!userEdit?.additionalSocialMediaChannels?.length"
      >
        <ng-container
          *ngFor="
            let adChannel of userEdit.additionalSocialMediaChannels;
            let i = index
          "
        >
          <div class="ad-channel-wrapper" id="ad-channel-{{ i }}">
            <ops-input
              (validationError)="onErrorHandler($event, adChannel.name)"
              [isPreview]="isPreview"
              label="{{ adChannel.name }}"
              formName="{{ adChannel.name }}"
              [value]="adChannel.url"
              (changed)="onAdditionalChannelChange($event, adChannel.name)"
              type="url"
            ></ops-input>
            <button
              tabindex="-1"
              *ngIf="!isPreview"
              (click)="removeAdChannel(adChannel)"
            >
              {{ 'labels.remove' | translate }}
            </button>
          </div>
        </ng-container>
      </div>
      <ops-add-additional-media-channel
        [isPreview]="isPreview"
        (createdChannel)="createNewChannel($event)"
      ></ops-add-additional-media-channel>
    </div>

    <div class="settings-section">
      <label class="section-label fun-stuff">{{
        'labels.funStuff' | translate
      }}</label>
      <div class="profile-form two-cols">
        <div class="left-block">
          <ops-select
            [isPreview]="isPreview"
            [options]="starSigns"
            rotateDropdownDirection="true"
            showSearch="true"
            allowCreate="true"
            [defaultSelected]="userEdit.starSign"
            [formName]="userEdit.starSign"
            [label]="'labels.starSign' | translate"
            (changed)="onSelectChange($event, 'starSign')"
          ></ops-select>

          <ops-select
            [isPreview]="isPreview"
            [options]="personalities"
            showSearch="true"
            allowCreate="true"
            rotateDropdownDirection="true"
            [defaultSelected]="userEdit.sixteenPersonalities"
            [formName]="userEdit.sixteenPersonalities"
            [label]="'labels.sixteenPersonalities' | translate"
            (changed)="onSelectChange($event, 'sixteenPersonalities')"
          ></ops-select>
        </div>
        <div class="right-block">
          <ops-select
            [isPreview]="isPreview"
            [options]="zodiacSigns"
            rotateDropdownDirection="true"
            showSearch="true"
            allowCreate="true"
            [defaultSelected]="userEdit.zodiacSign"
            [formName]="userEdit.zodiacSign"
            [label]="'labels.zodiacSign' | translate"
            (changed)="onSelectChange($event, 'zodiacSign')"
          ></ops-select>

          <ops-select
            [isPreview]="isPreview"
            [options]="ennagrams"
            showSearch="true"
            allowCreate="true"
            rotateDropdownDirection="true"
            [defaultSelected]="userEdit.enneagram"
            [formName]="userEdit.enneagram"
            [label]="'labels.enneagram' | translate"
            (changed)="onSelectChange($event, 'enneagram')"
          ></ops-select>
        </div>
      </div>
    </div>
  </div>
</div>
